import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6330ee75"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "searchFrom" }
const _hoisted_2 = { style: {"margin-top":"20px"} }
const _hoisted_3 = { style: {"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis","max-width":"200px"} }
const _hoisted_4 = { style: {"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis","max-width":"200px"} }
const _hoisted_5 = { class: "work-list-user-cell" }
const _hoisted_6 = { class: "work-list-user-cell__name" }
const _hoisted_7 = { class: "work-list-user-cell__id" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_XAtable = _resolveComponent("XAtable")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_x_dialog = _resolveComponent("x-dialog")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_form, {
        name: "customized_form_controls",
        layout: "inline",
        model: $setup.searchFormState
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, { label: "状态" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: $setup.searchFormState.status,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchFormState.status) = $event)),
                placeholder: "请选择状态",
                style: {"min-width":"120px"},
                allowClear: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode("等待处理")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode("已处理")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 2 }, {
                    default: _withCtx(() => [
                      _createTextVNode("工单驳回")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "类型" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: $setup.searchFormState.type,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (($setup.searchFormState.type) = $event)),
                placeholder: "请选择类型",
                style: {"min-width":"120px"},
                allowClear: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode("其他")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode("账户资金清零")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 2 }, {
                    default: _withCtx(() => [
                      _createTextVNode("换绑BM")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            name: "createBy",
            label: "创建者(户)"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: $setup.searchFormState.createBy,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (($setup.searchFormState.createBy) = $event)),
                placeholder: "请选择或搜索创建者(户)",
                "show-search": "",
                "filter-option": false,
                onSearch: $setup.handleCreatorFilterSearch,
                onPopupScroll: $setup.handleCreatorFilterScroll,
                onFocus: $setup.handleCreatorFilterFocus,
                onClear: $setup.handleCreatorFilterClear,
                loading: $setup.creatorFilterLoading,
                "option-label-prop": "label",
                "allow-clear": "",
                style: {"min-width":"260px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.creatorFilterList, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: item.id,
                      value: item.id,
                      label: item.name
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "onSearch", "onPopupScroll", "onFocus", "onClear", "loading"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                style: {"margin-right":"10px"},
                onClick: $setup.resetForm
              }, {
                default: _withCtx(() => [
                  _createTextVNode("重置")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: $setup.search,
                style: {"margin-right":"10px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("搜索")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createVNode(_component_a_alert, {
      message: "本模块为原工单管理，现在已分离，保留历史数据记录",
      type: "info",
      "show-icon": "",
      style: {"margin-top":"20px","margin-bottom":"20px"}
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_XAtable, {
        columns: $setup.columns,
        dataSource: $setup.tableData,
        loading: $setup.loading,
        scroll: { x: 720 }
      }, {
        status: _withCtx(({ scope }) => [
          _createVNode(_component_a_tag, {
            color: 
            scope.record.status === 0
              ? 'orange'
              : scope.record.status === 1
              ? 'green'
              : 'red'
          
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(scope.record.status === 0
              ? "等待处理"
              : scope.record.status === 1
              ? "已处理"
              : "工单驳回"), 1)
            ]),
            _: 2
          }, 1032, ["color"])
        ]),
        type: _withCtx(({ scope }) => [
          _createElementVNode("span", null, _toDisplayString(scope.record.type === 0
            ? "其他"
            : scope.record.type === 1
            ? "账户资金清零"
            : "换绑BM"), 1)
        ]),
        txt: _withCtx(({ scope }) => [
          _createVNode(_component_a_tooltip, {
            title: scope.record.txt || ''
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, _toDisplayString(scope.record.txt || "-"), 1)
            ]),
            _: 2
          }, 1032, ["title"])
        ]),
        remark: _withCtx(({ scope }) => [
          _createVNode(_component_a_tooltip, {
            title: scope.record.remark || ''
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, _toDisplayString(scope.record.remark || "-"), 1)
            ]),
            _: 2
          }, 1032, ["title"])
        ]),
        userId: _withCtx(({ scope }) => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(scope.record.userName || "—"), 1),
            _createElementVNode("div", _hoisted_7, " ID：" + _toDisplayString(scope.record.userId ?? "—"), 1)
          ])
        ]),
        createBy: _withCtx(({ scope }) => [
          _createElementVNode("div", null, _toDisplayString(scope.record.createByName), 1)
        ]),
        control: _withCtx(({ scope }) => [
          (scope.record.status === 0)
            ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                type: "primary",
                size: "small",
                onClick: ($event: any) => ($setup.auditClick(scope.record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("审核")
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_permission, 'sysWork.list.update']
              ])
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["columns", "dataSource", "loading"]),
      _createVNode(_component_a_pagination, {
        current: $setup.pageNo,
        "onUpdate:current": _cache[3] || (_cache[3] = ($event: any) => (($setup.pageNo) = $event)),
        onChange: $setup.pageNoChange,
        total: $setup.total,
        hideOnSinglePage: "",
        onShowSizeChange: $setup.onShowSizeChange,
        style: {"margin-top":"5px"}
      }, null, 8, ["current", "onChange", "total", "onShowSizeChange"])
    ]),
    _createVNode(_component_x_dialog, {
      title: "审核工单",
      visible: $setup.dialogVisible,
      onCancel: $setup.handleCancel,
      onIsDestroyOnClose: _cache[9] || (_cache[9] = ($event: any) => {$setup.auditLoading = false;}),
      onConfirm: $setup.confirm,
      loading: $setup.auditLoading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: $setup.formState,
          ref: "formRef",
          labelCol: { span: 4, offset: 0 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "广告账户ID" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: $setup.formState.adsId,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (($setup.formState.adsId) = $event)),
                  disabled: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "工单内容" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: $setup.formState.txt,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (($setup.formState.txt) = $event)),
                  disabled: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "类型" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: $setup.formState.type,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (($setup.formState.type) = $event)),
                  placeholder: "请选择类型",
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode("其他")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("账户资金清零")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => [
                        _createTextVNode("换绑BM")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "状态",
              name: "status",
              rules: [{ required: true, message: '请选择状态!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: $setup.formState.status,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (($setup.formState.status) = $event)),
                  placeholder: "请选择状态"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("已处理")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => [
                        _createTextVNode("工单驳回")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "审核意见",
              name: "remark",
              rules: [{ required: true, message: '请输入审核意见!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  placeholder: "请输入审核意见",
                  value: $setup.formState.remark,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (($setup.formState.remark) = $event)),
                  rows: 3
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "onCancel", "onConfirm", "loading"])
  ], 64))
}